import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
	selector: '[dataLayer-host]',	
  	standalone: false
})

export class DataLayerDirective {
	constructor(public viewContainerRef: ViewContainerRef ) {}
}
